module.exports = __webpack_public_path__ + "img/logo-03.d80deb9b.png";